import React from 'react'

import * as c from '../../common'
import * as r from '../../react-utils'

import NumberInput from './NumberInput'

export type ConnectedNumberInput = c.r<{
  customerID: string
  disabled?: boolean
  field: c.CustomerField
  on: c.Surface
}>

export default React.memo<ConnectedNumberInput>(function ConnectedNumberInput({
  customerID,
  disabled,
  field,
  on,
}) {
  //#region global
  const [customer] = r.useCustomer(customerID)
  const [fieldVal, setFieldVal] = r.useCustomerField(customerID, field)
  const handleChange = React.useCallback(
    (newVal: number) => {
      setFieldVal(newVal)
    },
    [setFieldVal],
  )
  //#endregion

  return (
    <NumberInput
      allowDecimals={c.CustomerSchema[field] === c.PositiveFloat}
      disabled={disabled}
      grow
      hide={c.shouldHideInput(field, customer)}
      label={c.getFieldLabel(field)}
      on={on}
      onChange={handleChange}
      value={fieldVal as number}
    />
  )
})
